import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map, isEmpty } from 'lodash';

import {
    domainsDataBySender
} from '../sender-details/selectors/sender-details-selectors';
import {
    rightPaneAttributesSelector
} from '../common/selectors/right-pane-selectors';
import {
    updateDomainsForARecognizedSender
} from '../common/actions/recognized-senders-action-creators';

import VerificationByDomainModal from './verification-by-domain-modal';

export class VerificationByDomainModalContainer extends Component{
    constructor( props ){
        super( props );

        this.state = {
            updatedDomainsMap: {}
        };
    }

    handleSave = () => {
        const { updateDomainsForARecognizedSender, senderId } = this.props;
        const { updatedDomainsMap } = this.state;

        const deltaDomainStatusList = map( updatedDomainsMap, ( status, domain ) => ( { domain, status } ) );

        updateDomainsForARecognizedSender( senderId, deltaDomainStatusList );
    }

    handleCancel = () => {
        this.setState( {
            updatedDomainsMap: {}
        } );
        this.props.onClose();
    }

    updateSenderStatus = ( domain ) => ( event ) => {
        this.setState( {
            updatedDomainsMap: {
                ...this.state.updatedDomainsMap,
                [domain]: event.target.value
            }
        } );
    };

    render(){
        const { domains, open, senderName } = this.props;
        const { updatedDomainsMap } = this.state;

        const temporaryUpdatedDomains = domains.map( domain => {
            if( this.state.updatedDomainsMap[domain.id] ){
                return {
                    ...domain,
                    status: this.state.updatedDomainsMap[domain.id]
                };
            }
            else{
                return domain;
            }
        } );

        return (
            <VerificationByDomainModal
                domains={temporaryUpdatedDomains}
                editMode={true}
                senderName={senderName}
                open={open}
                onClose={this.handleCancel}
                onSave={this.handleSave}
                onSelection={this.updateSenderStatus}
                saveDisabled={isEmpty( updatedDomainsMap )}
            />
        );
    }
};

/* istanbul ignore next */
function mapStateToProps( state ){
    return {
        domains: domainsDataBySender( state ),
        senderId: rightPaneAttributesSelector( state ).senderId || '',
        senderName: rightPaneAttributesSelector( state ).senderName || '',
    };
}

VerificationByDomainModalContainer.propTypes = {
    domains: PropTypes.array.isRequired,
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    senderId: PropTypes.string.isRequired,
    senderName: PropTypes.string.isRequired,
    updateDomainsForARecognizedSender: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    { updateDomainsForARecognizedSender }
)( VerificationByDomainModalContainer );
